// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer-module--Footer--1jEo_"};